import React from 'react';
import { useSelector } from 'react-redux';
import Disclaimer from '../../../../component/disclaimer';
import { colorsPieCharts } from '../../../../shared/constants';
import { FormattedData } from '../../charts/types';
import { AgeDistribution } from './ageDistribution';
import { ResidenceCondition } from './residenceCondition';
import { GenderDistribution } from './genderDistribution';
import { PopulationGrowth } from './populationGrowth';
import { TypesOfResidence } from './typesOfResidence';
import { HouseholdsByIncome } from './householdsByIncome';
import { DwellersByResidence } from './dwellersByResidence';
import { ActivePopulation } from './activePopulation';
import { ConsumptionByIncome } from './consumptionByIncome';
import './socioeconomicDemographic.scss';
import { ConsumptionByGoods } from './consumptionByGoods';

export const generateTitleAndSource = (
  title: string,
  tooltipText: string
): JSX.Element => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../nls/${preference.language.id}.json`);
  return (
    <div className="socioeconomic-title-container">
      <p>{title}</p>
      <div className="socioeconomic-source-disclaimer">
        <Disclaimer
          element={tooltipText}
          cy={'SocioeconomicSource'}
          colorIcon={'#6F7171'}
          position="bottom"
        />
        <p>{nls.source}</p>
      </div>
    </div>
  );
};

export const renderLegend = (payload: FormattedData[]): JSX.Element => {
  if (!payload) return <></>;
  return (
    <ul style={{ listStyleType: 'none', padding: 0, margin: '30px 20px' }}>
      {payload.map((entry, index) => (
        <li
          key={`item-${index}`}
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            margin: '5px 0px',
          }}
        >
          <div
            style={{
              backgroundColor: colorsPieCharts[index],
              borderRadius: '50%',
              minWidth: '10px',
              width: '10px',
              height: '10px',
              marginRight: '5px',
              marginTop: '6px',
            }}
          ></div>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            <span style={{ textAlign: 'left' }}>{entry.name}:&nbsp;</span>
            <span style={{ textAlign: 'left' }}>{entry.percentage}</span>
          </div>
        </li>
      ))}
    </ul>
  );
};

export const calculateWidthConsumptionGoods = (
  chosenAmmount: number,
  remainingAmmount: number
): number => {
  return (chosenAmmount / (chosenAmmount + remainingAmmount)) * 100;
};

export const SocioeconomicDemographicCharts: React.FC = () => {
  const { isGridView } = useSelector((state: any) => state.chartsState);
  return (
    <div className="socioeconomic-demographic-charts">
      <div
        className={`socioeconomic-pie-chart-distribution-container ${
          !isGridView && 'list-layout'
        }`}
      >
        <GenderDistribution />
        <AgeDistribution />
      </div>
      <div
        className={`socioeconomic-pie-chart-population-growth-container ${
          !isGridView && 'list-layout'
        }`}
      >
        <PopulationGrowth />
      </div>
      <div
        className={`socioeconomic-pie-charts-information-residence ${
          !isGridView && 'list-layout'
        }`}
      >
        <TypesOfResidence />
        <ResidenceCondition />
        <DwellersByResidence />
      </div>
      <div
        className={`socioeconomic-bar-chart-households-container ${
          !isGridView && 'list-layout'
        }`}
      >
        <HouseholdsByIncome />
        <ActivePopulation />
      </div>
      <div
        className={`socioeconomic-tree-chart-consumption-container ${
          !isGridView && 'list-layout'
        }`}
      >
        <ConsumptionByIncome />
        <ConsumptionByGoods />
      </div>
    </div>
  );
};
